// firebase 초기화

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { Auth, getAuth } from "firebase/auth";
import { Firestore, getFirestore } from "firebase/firestore";
import {
  Functions,
  connectFunctionsEmulator,
  getFunctions,
} from "firebase/functions";
import { FirebaseStorage, getStorage } from "firebase/storage";
import { getAnalytics, isSupported, Analytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_apiKey,
  authDomain: process.env.REACT_APP_authDom,
  projectId: process.env.REACT_APP_project,
  storageBucket: process.env.REACT_APP_storage,
  messagingSenderId: process.env.REACT_APP_messageId,
  appId: process.env.REACT_APP_appId,
  measurementId: process.env.REACT_APP_measure,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const auth: Auth = getAuth(app);
const db: Firestore = getFirestore(app);
const storage: FirebaseStorage = getStorage(app);
const functionsRegion =
  (process.env.REACT_APP_FUNCTIONS_REGION || "asia-northeast3").trim() ||
  "asia-northeast3";
const functions: Functions = getFunctions(app, functionsRegion);

if (
  typeof window !== "undefined" &&
  window.location.hostname === "localhost" &&
  process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === "true"
) {
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}

export const analyticsPromise: Promise<Analytics | null> = isSupported()
  .then((yes) => (yes ? getAnalytics(app) : null))
  .catch(() => null);

export { app, auth, db, functions, storage };
